import styled, { css } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

export interface IScroll {
    scroll: boolean;
    src?: any;
}

interface ISelected {
    selected: boolean;
}

export const Tab = styled.div<ISelected>`
    flex-basis: 33%;
    flex-grow: 1;
    margin-bottom: 3px;
    height: 48px;
    box-sizing: border-box;
    padding: 12px 24px;
    color: #ffffff;
    opacity: 0.6;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 24px;
    text-align: center;
    transition: all 0.2s linear;
    cursor: pointer;
    backface-visibility: hidden;
    transform: translateZ(0) scale(1, 1);
    user-select: none;
    text-transform: uppercase;
    box-shadow: 0 3px ${rgba(colorsPalettes.orange[400], 0)};
    &:hover {
        opacity: 0.8;
    }
    ${(props) =>
        props.selected &&
        css`
            && {
                opacity: 1;
                box-shadow: 0 3px ${rgba(colorsPalettes.orange[400], 1)};
            }
        `}
`;
